import { colors } from '@chegg-ui/theme'
import { fanta } from '@chegg/fanta'
import { ThemedStyledProps } from 'styled-components'

const fantaTheme = {
  spacing: {
    fanta: { ...fanta.spacing },
    md2: '15px',
    md3: '20px',
  },
  border: {
    colors,
  },
  colors,
  font: {
    heading: {
      size: {
        sm: '20px',
        md: '28px',
        lg: '32px',
      },
    },
    text: {
      size: {
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '20px',
        xlg: '24px',
        '2xl': '32px',
        '3xl': '42px',
        '4xl': '48px',
      },
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extraBold: 800,
    },
  },
  space: [5, 10, 15, 20, 30],
  breakpoints: ['550px', '768px', '992px', '1200px'],
}

export default fantaTheme

export type ThemeProps<P> = ThemedStyledProps<P, typeof fantaTheme>
